module.exports = __webpack_public_path__ + "static/emails-joy-d0e3027e20a9ca9c7017d09974e2dea8.gif";